<template>
  <div class="my-5 mx-4">
    <div>
      <h1 class="text-center font-weight-light">
        Jobs and Day Training Attendance Log
      </h1>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :timeout="timeout" dark color="success">
      {{ text }}
    </v-snackbar>

    <v-card class="pa-4" outlined flat>
      <v-card-actions>
        <v-row>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn
            small
            color="blue-grey"
            dark
            class="mr-1"
            :loading="isDownloading"
            @click="download"
          >
            generate pdf
          </v-btn>
          <v-btn
            small
            color="success"
            dark
            :loading="isSaving"
            @click="onSaveItem"
          >
            save changes
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <div class="d-flex justify-start container mt-3">
      <div>
        <v-menu
          ref="dateFromMenu"
          v-model="dateFromMenu"
          :close-on-content-click="false"
          :return-value.sync="dateFrom"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFrom"
              label="Date From"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateFrom" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dateFromMenu = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dateFromMenu.save(dateFrom)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="ma-2">
        <span>-</span>
      </div>
      <div>
        <v-menu
          ref="dateToMenu"
          v-model="dateToMenu"
          :close-on-content-click="false"
          :return-value.sync="dateTo"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateTo"
              label="Date To"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateTo" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dateToMenu = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.dateToMenu.save(dateTo)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="d-flex flex-column align-self-center ml-1">
        <v-btn class="primary" @click="onFindItem">search</v-btn>
      </div>
    </div>

    <FormSheet ref="reports" :items="forms" :providers="providers" />
  </div>
</template>

<script>
/*eslint-disable */
import { mapActions, mapGetters } from "vuex";
import FormSheet from "./FormSheet";
import download from "downloadjs";
import DatePicker from "@/components/DateTimePickers/DatePicker";

export default {
  components: {
    FormSheet,
    DatePicker,
  },
  data() {
    return {
      forms: {
        staffs: [{}],
        timesheets: [{}],
      },
      isDownloading: false,
      isSaving: false,
      snackbar: false,
      text: "Successfully Saved",
      overlay: false,
      timeout: 1000,
      dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateFromMenu: false,
      dateToMenu: false,
      providers: [],
    };
  },

  created() {
    this.fetch();
  },

  computed: {
    ...mapGetters({
      clientAttendance: "attendance/clientAttendance",
      client: "clients/clientData",
    }),
  },

  methods: {
    ...mapActions({
      getJDTAttendanceReportPDF: "dataTracking/getJDTAttendanceReportPDF",
      createDataTracking: "dataTracking/createDataTracking",
      getDataTracking: "dataTracking/getDataTracking",
      getClientAttendance: "attendance/getClientAttendance",
      getClientInfo: "clients/getClient",
      getClientProviders: "clientProviders/getItem",
    }),

    async download() {
      this.isDownloading = true;
      this.items = this.$refs.reports.getData();

      const result = await this.getJDTAttendanceReportPDF(this.items);

      let pdfFile =
        "data:application/octet-stream;base64," + result.data.result;

      let fileName = `JDT-Attendance-Log-${Date.now()}.pdf`;

      download(pdfFile, fileName, "application/pdf");
      this.isDownloading = false;
    },

    async onSaveItem() {
      this.isSaving = true;
      this.items = this.$refs.reports.getItems();
      const data = {
        data: this.items,
        params: {
          clientId: this.$route.params.clientID,
          staffId: localStorage.getItem("staffId"),
          type: "JDTAttendanceLog",
        },
      };

      await this.createDataTracking(data);
      this.isSaving = false;
      this.snackbar = true;
    },

    async onFindItem() {
      try {
        this.overlay = true;
        this.forms.timesheets = [];
        const response = await this.getClientAttendance({
          clientId: this.$route.params.clientID,
          startDate: this.dateFrom,
          endDate: this.dateTo,
        });

        const attendance = response.map((item) => ({
          ...item,
          totalHours: this.calculateWorkingHours(item.TimeStart, item.TimeEnd),
          start: item.TimeStart,
          end: item.TimeEnd,
          individualInitials: this.createInitials(this.client.Name),
          staffInitials: this.createInitials(item.Signature.split(" - ")[0]),
          signature: item.Signature,
          date: item.Date,
        }));

        this.forms.timesheets.push(...attendance);
        this.overlay = false;
      } catch (e) {
        this.overlay = false;
      }
    },

    async fetch() {
      const response = await this.getDataTracking({
        clientId: this.$route.params.clientID,
        staffId: localStorage.getItem("staffId"),
      });

      const clientProviders = await this.getClientProviders(
        this.$route.params.clientID
      );
      this.providers = clientProviders.data;

      await this.getClientInfo(this.$route.params.clientID);

      const hasForm = !!response.result?.forms?.JDTAttendanceLog;

      if (hasForm) {
        return (this.forms = {
          ...response.result.forms.JDTAttendanceLog,
          individualName: this.client.Name,
          caseNo: this.client.Case,
        });
      }

      this.forms = {
        ...this.forms,
        individualName: this.client.Name,
        caseNo: this.client.Case,
      };
    },

    calculateWorkingHours(timeStart, timeEnd) {
      if (!timeStart || !timeEnd) {
        return "0";
      }

      const start = new Date(
        `1970-01-01T${this.convertTo24HourFormat(timeStart)}`
      );
      const end = new Date(`1970-01-01T${this.convertTo24HourFormat(timeEnd)}`);

      const difference = end - start;

      let hours = difference / (1000 * 60 * 60);

      hours = Math.round(hours * 4) / 4;

      return hours.toString();
    },

    convertTo24HourFormat(time) {
      const [timePart, modifier] = time.split(/([a-zA-Z]+)/);
      let [hours, minutes] = timePart.trim().split(":");

      hours = parseInt(hours, 10);
      minutes = parseInt(minutes, 10);

      if (modifier.toLowerCase() === "pm" && hours !== 12) {
        hours += 12;
      } else if (modifier.toLowerCase() === "am" && hours === 12) {
        hours = 0;
      }

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:00`;
    },

    createInitials(name) {
      return name
        ? name
            .split(" ")
            .map((staff) => staff[0])
            .join("")
        : "";
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

/* .container {
  background-color: red;
} */
</style>
